import { render, staticRenderFns } from "./BrightnessLogsList.vue?vue&type=template&id=476de825&"
import script from "./BrightnessLogsList.vue?vue&type=script&lang=js&"
export * from "./BrightnessLogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports